import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  SYSTEM_ROLE_LABEL,
  SYSTEM_ROLE_NONE,
  SYSTEM_ROLE_OPTIONS,
  SystemRole,
} from '../../../../../Enums/system-role.enum';
import {
  SystemRoleDialogData,
  SystemRoleDialogResult,
} from '../../../Interfaces/system-role-dialog.interface';

@Component({
  selector: 'app-system-role-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './system-role-dialog.component.html',
  styleUrl: './system-role-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemRoleDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<SystemRoleDialogComponent, SystemRoleDialogResult>>(MatDialogRef);

  readonly data = inject<SystemRoleDialogData>(MAT_DIALOG_DATA);

  readonly roleOptions = SYSTEM_ROLE_OPTIONS;
  readonly roleLabelKeys = SYSTEM_ROLE_LABEL;
  readonly noneValue = SYSTEM_ROLE_NONE;

  readonly formGroup: FormGroup = this._formBuilder.group({
    system_role: [this.data.currentRole ?? SYSTEM_ROLE_NONE, [Validators.required]],
    force: [false],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    const selected = String(this.formGroup.value.system_role);

    this._dialogRef.close({
      systemRole: selected === SYSTEM_ROLE_NONE ? null : (selected as SystemRole),
      force: Boolean(this.formGroup.value.force),
    });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
